import baseStore from '../generic_store';
import Axios from "axios";

const base = baseStore('buildings');

const state = {
    ...base.state,
    base_url: '/api/buildings',
    resourceName: 'Bâtiment',
    isSyncPending: false,
    model: {
        name: null,
        building_id: null,
        adlead_id: null,
        translatable: {
            description: {
                fr: '',
                en: ''
            },
        },
        description: {
            fr: '',
            en: ''
        },
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
    sync({state, commit, getters, dispatch}, {id: id}) {
        state.isSyncPending = true;

        return Axios.post(`${getters.base_url}/${id}/sync` )
            .then(response => {
                dispatch('toasts/add', {type: 'success', message: 'Sync done'}, {root: true})
            })
            .catch(error => {
                console.warn(error);
                if (error.response && error.response.status === 404) {
                    dispatch('toasts/add', {type: 'error', message: 'Resource item not found'}, {root: true})
                }
            })
            .finally(() => {
                state.isSyncPending = false;
            });
    },
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
